import { render, staticRenderFns } from "./ClassGroups.vue?vue&type=template&id=47b6453c&scoped=true&"
import script from "./ClassGroups.vue?vue&type=script&lang=js&"
export * from "./ClassGroups.vue?vue&type=script&lang=js&"
import style0 from "./ClassGroups.vue?vue&type=style&index=0&id=47b6453c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b6453c",
  null
  
)

export default component.exports